<template>
	<div class="item-content" style="align-items: baseline;">
		<div class="item-media">
			<button class="button button-fill color-deeppurple">{{(pageNo > 0)?(pageNo + "p. "):("")}}{{examNo}}.</button>
			<div v-if="mode == 'SCORE'" class="score-image" :style="'background-image:url('+scoreImage()+');'"></div>
		</div>
		<div class="item-inner item-cell">
			<div v-if="mode == 'ANSWER'" style="margin-bottom:4px;">
				<template v-for="(lecture, i) in lectures">
					<a class="text-color-primary margin-right" :key="'i' + i" v-if="lecture.blockOrder <= 10" style="white-space: nowrap;" v-on:click="onShowLectureClick($event, i)">
						<i class="f7-icons text-color-purple" style="vertical-align: text-bottom;">{{getIconName(lecture.lectureType)}}</i>
						<span>{{getLevelName(lecture.lectureLevel)}}</span>
					</a>
				</template>
			</div>
			<div v-else style="margin-bottom:4px;">
				<template v-for="(lecture, i) in lectures">
					<a v-bind:class="(correct != 'o') ? 'text-color-primary':'text-color-gray'" class="margin-right" :key="'i' + i" v-if="lecture.blockOrder > 10" style="white-space: nowrap;" v-on:click="onShowLectureClick($event, i)">
						<i class="f7-icons" v-bind:class="(correct != 'o') ? 'text-color-purple':'text-color-gray'" style="vertical-align: text-bottom;">{{getIconName(lecture.lectureType)}}</i>
						<span>{{getLevelName(lecture.lectureLevel)}}</span>
					</a>
				</template>
			</div>
			<div class="item-row">
				<div class="item-cell">
					서술형 문제
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MODULE from '../../js/common/module';
import store from '../../js/store';
import CONST from '../../js/common/constant';
import AUTH from '../../js/common/auth';

import videojs from 'video.js';

export default {
	components: {
		
	},
	props: {
		seqIndex: { default: 0 },
		pageNo: { default: 0 },
		examNo: { default: 0 },
	},
	data() {
		return {
			
		}
	},
	computed: {
		mode() {
			var mode = this.getCommonObj().mode;
			return mode;
		},
		answer() {
			return this.getExam().answer;
		},
		inputAnswer: {
			get() {
				return this.getExam().inputAnswer;
			},
			set(newValue) {
				var exam = this.getExam();
				exam.inputAnswer = newValue;
			}
		},
		correct() {
			var correct = this.getExam().correct;
			if (MODULE.Util.isEmpty(correct)) {
				correct = "null";
			}

			return correct;
		},
		lectures() {
			return this.getExam().lectures;
		}
	},
	methods: {
		getCommonObj() {
			return store.getters.commonObj;
		},
		getExam() {
			var answers = this.getCommonObj().answers;

			var exam = answers[this.seqIndex];
			return exam;
		},
		isSelected(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.inputAnswer.includes(exampleNo);
		},
		isDisplayAnswer(exampleIndex) {
			var exampleNo = Number(exampleIndex) + 1;
			return this.mode=="SCORE" && this.answer.includes(exampleNo);
		},
		getIconName(lectureType) {
			if (lectureType == "c-otl" || lectureType == "e-otl") {
				return "arrowtriangle_right_circle";
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				return "videocam_circle"
			} else if (lectureType == "c-img" || lectureType == "e-img") {
				return "photo";
			} else {
				return "question";
			}
		},
		getLevelName(lectureLevel) {
			return CONST.lectureLevelMap[lectureLevel].name;
		},
		scoreImage() {
			var correct = this.getExam().correct;

			if (MODULE.Util.isEmpty(correct)) {
				correct = "null";
			}

			return "static/score/" + correct + ".png";
		},
		onShowLectureClick(e, index) {
			var lectures = this.lectures;
			var lecture = lectures[index];
			var lectureType = lecture.lectureType;
			var lectureCode = lecture.lectureCode;

			if (lectureType == "c-img" || lectureType == "e-img") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-mp4" || lectureType == "e-mp4") {
				MODULE.UITool.openMP4Dialog(lectureCode);
			} else if (lectureType == "c-otl" || lectureType == "e-otl") {
				const accessToken = AUTH.getAccessToken();
				MODULE.Util.appCall(accessToken, "show.otl", "lcode", lectureCode);
			}
		},
	}
}
</script>